import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import { mask } from 'remask';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { instanceAxios } from '../../InstanceAxios';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import HeadTable from '../../components/HeadTable';
import Button from '@material-ui/core/Button';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  loading: {
    marginLeft: '50%',
  },
}));

function ClientesTron() {
  const TelefonePattern = ['(99)99999-9999'];
  const CpfPattern = ['999.999.999-99'];
  const RgPattern = ['99.99.999'];
  const CNPJPattern = ['99.999.999/9999-99'];
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [originalUsuarios, setOriginalUsuarios] = useState([]);

  const [usuarios, setUsuarios] = useState([]);
  const [busca, setBusca] = useState('');
  const [ready, setReady] = useState(false);
  const [perfis, setPerfis] = useState([]);
  const [columns, setColumns] = useState([
    { id: 'nome', label: 'Nome', minWidth: 140, filterable: true },
    { id: 'empresa', label: 'Empresa', minWidth: 140, filterable: true },
    { id: 'ver', label: '', minWidth: 140, filterable: false },
  ]);
  const [usuario, setUsuario] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [checked, setChecked] = useState([]);
  const [novo, setNovo] = useState(true);
  const [campoOrdenacao, setCampoOrdenacao] = useState('');
  const [ordem, setOrdem] = useState('');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  const showUser = (u) => {
    setUsuario(u);
    setOpenModal(true);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      setReady(false);
      console.log(limit);
      console.log(page);
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(
          `/tron/usuarios?data=2019-01-01 00:00:00&limit=${limit}&page=${page}&busca=${busca}`
        )
        .then((res) => {
          const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];

          setUsuarios(rows);
          setOriginalUsuarios(rows);
          setCount(res?.data?.count || 0);
          setReady(true);
        })
        .catch((err) => {
          console.log(err);
          setReady(true);
        });
    };

    fetchUsers();
  }, [limit, page, busca]);

  const openModalFilter = (event, columnid) => {
    setFilterText('');
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top, left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalUsuarios.filter((item) => {
      const value = getValueColumnId(columnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    setUsuarios(filteredDas);
  };

  const getValueColumnId = (columnIdAux, rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  };

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setUsuarios(originalUsuarios);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;

    if (idOrder === property && order === 'desc') {
      setOrder('asc');
    } else {
      setOrder('desc');
    }

    setIdOrder(orderBy);
  };

  const sortTable = (property) => {
    const isAsc = order === 'asc';
    const usuariosOrdenados = Array.isArray(usuarios) ? [...usuarios] : [];
    console.log(isAsc);
    console.log(usuariosOrdenados);
    usuariosOrdenados.sort((a, b) => {
      let aValue = getValueColumnId(property, a);
      let bValue = getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setUsuarios(usuariosOrdenados);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 20,
      }}
    >
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        style={{ top: modalPosition.top, left: modalPosition.left }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            width: '300px',
          }}
        >
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={filterTable}
            style={{ marginTop: '10px' }}
          >
            Filtrar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={clearFilter}
            style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
          >
            Limpar
          </Button>
        </div>
      </Modal>
      <div align="center">
        <h1>Usuários</h1>
      </div>
      <Paper style={{ width: '95%' }}>
        <div align="right">
          <TextField
            id="busca"
            label="Busca"
            value={busca}
            onChange={async (event) => setBusca(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            style={{
              margin: '2vh',
              minWidth: '30vh',
            }}
          />
        </div>
        <Collapse in={ready}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {column.filterable && (
                        <IconButton
                          style={{ marginLeft: -5 }}
                          onClick={(event) => openModalFilter(event, column.id)}
                          aria-label="filtra"
                        >
                          <FilterIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(usuarios) ? usuarios : []).map((u) => {
                return (
                  <TableRow key={u.id}>
                    <TableCell component="th" scope="row" align="center">
                      {u.nome}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {u.UsuarioEmpresa
                        ? u.UsuarioEmpresa.Empresa.razao_social
                        : ''}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <IconButton
                        onClick={() => showUser(u)}
                        style={{
                          color: XMEI_PRIMARY_COLOR,
                        }}
                        aria-label="Ver Dados Cliente"
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={count}
                style={{ backgroundColor: '#FFF' }}
                rowsPerPage={limit}
                page={page}
                onChangePage={(event, newPage) => {
                  setPage(newPage);
                }}
                onChangeRowsPerPage={(event) => {
                  setPage(0);
                  setLimit(event.target.value);
                }}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={!ready}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Grid
          container
          spacing={3}
          className={classes.paper}
          style={{
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
            width: '80%',
            height: '80%',
            overflow: 'auto',
          }}
        >
          <Grid item xs={12}>
            <div align="center">
              <Typography variant="h4">Usuário</Typography>
            </div>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="nome"
              label="Nome"
              variant="outlined"
              value={usuario.nome}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="email"
              label="Email"
              variant="outlined"
              value={usuario.email}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="telefone"
              label="Telefone"
              variant="outlined"
              value={
                usuario.telefone ? mask(usuario.telefone, TelefonePattern) : ''
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="data_nascimento"
              label="Data Nascimento"
              variant="outlined"
              value={usuario.data_nascimento}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="cpf"
              label="cpf"
              variant="outlined"
              value={usuario.cpf ? mask(usuario.cpf, CpfPattern) : ''}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="sexo"
              label="Sexo"
              variant="outlined"
              value={usuario.sexo}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="nome_mae"
              label="Nome da Mãe"
              variant="outlined"
              value={usuario.nome_mae}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="rg"
              label="RG"
              variant="outlined"
              value={usuario.cpf ? mask(usuario.rg, RgPattern) : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider variant="fullWidth" />
          </Grid>
          <Grid item xs={12}>
            <div align="center">
              <Typography variant="h4">Empresa</Typography>
            </div>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="razao_social"
              label="Razão Social"
              variant="outlined"
              value={
                usuario.UsuarioEmpresa
                  ? usuario.UsuarioEmpresa.Empresa.razao_social
                  : ''
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="cnpj"
              label="CNPJ"
              variant="outlined"
              value={
                usuario.UsuarioEmpresa
                  ? mask(usuario.UsuarioEmpresa.Empresa.cnpj, CNPJPattern)
                  : ''
              }
            />
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
}

export default ClientesTron;
